import { Checkbox } from '@mui/material'
import { Priorities } from 'Components/SharedComponents/Surveys/types'
import { Resource } from 'Generated/academy-graphql-types'
import {
  Description,
  RecommendedResource,
  RecommendedResourcesContainer,
  Title,
  Tag,
  CheckboxContainer,
} from './RecommendedResources.styled'
import { ToggleSaveOrClearOperation } from '../../types'
import { stringToTitleCase } from '../../../Academy/_common/utils'

type RecommendedResourcesProps = {
  onBookmark: (
    operation: ToggleSaveOrClearOperation,
    resourceId?: string
  ) => void
  priorities: Priorities
  resources: Resource[]
  resourcesToBookmark: string[]
}

export const RecommendedResources = ({
  onBookmark,
  priorities,
  resources,
  resourcesToBookmark,
}: RecommendedResourcesProps) => {
  if (!resources.length) return null

  const { firstPriority, secondPriority, thirdPriority, missingPriority } =
    priorities

  // Find the first match from the resource tags as nonprofitTopic is not always a direct category match
  const categories = [
    firstPriority.category,
    secondPriority.category,
    thirdPriority.category,
    missingPriority.category,
  ].map((tag) => tag.split('_').join(' ').toLowerCase())

  return (
    <RecommendedResourcesContainer>
      {resources.map((resource) => {
        const foundTag = resource.tags.find((tag) => categories.includes(tag))
        const tag = foundTag ? stringToTitleCase(foundTag) : ''
        return (
          <RecommendedResource key={resource.id}>
            <Tag>{tag}</Tag>
            <CheckboxContainer>
              <Checkbox
                onChange={() => onBookmark('toggle', resource.id)}
                checked={resourcesToBookmark.includes(resource.id)}
              />
            </CheckboxContainer>
            <Title>{resource.title}</Title>
            <Description>{resource.description}</Description>
          </RecommendedResource>
        )
      })}
    </RecommendedResourcesContainer>
  )
}
